export const OCI_REGEX = new RegExp("^/cloud-providers/oci/compartments/[^/]+$");
